import { SVGProps } from 'react';

const SvgVideo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M64 112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128c0-35.3 28.7-64 64-64h256c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm528 235.4V148.6L416 199v-52.6l104.3-46.9c5.1-2.3 10.6-3.5 16.2-3.5 21.8 0 39.5 17.7 39.5 39.5v241c0 21.8-17.7 39.5-39.5 39.5-5.6 0-11.1-1.2-16.2-3.5L416 365.6V313l112 50.4z" />
  </svg>
);
export default SvgVideo;
